import { render, staticRenderFns } from "./capabilitiesSlider.vue?vue&type=template&id=2778aa32"
import script from "./capabilitiesSlider.vue?vue&type=script&lang=js"
export * from "./capabilitiesSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports